import { DateTime } from 'luxon';
import { parseDateTime } from './dates';

export type CountdownState =
  | { type: 'none' }
  | { type: 'hourly'; hours: number }
  | { type: 'minutely'; minutes: number }
  | { type: 'expired' };

export const getNowInZone = (zone: string): DateTime => {
  return DateTime.now().setZone(zone);
};

export const getZoneFromDate = (dateStr: string, timezone?: string): string => {
  const parsed = parseDateTime(dateStr, timezone);
  return parsed.zone.name ?? 'local';
};

export const getCountdownState = (
  validTo: DateTime,
  validFrom: DateTime,
  nowInZone: DateTime,
): CountdownState => {
  const diffMs = validTo.toMillis() - nowInZone.toMillis();
  if (nowInZone < validFrom) return { type: 'none' };

  if (diffMs <= 0) return { type: 'expired' };

  const diffHours = diffMs / (1000 * 60 * 60);
  if (diffHours > 48) return { type: 'none' };

  if (diffHours <= 1) {
    return { type: 'minutely', minutes: Math.ceil(diffMs / (1000 * 60)) };
  }

  return { type: 'hourly', hours: Math.ceil(diffHours) };
};

export const isValidToday = (
  validFrom: DateTime,
  validTo: DateTime,
  nowInZone: DateTime,
): boolean => {
  return nowInZone >= validFrom && nowInZone <= validTo;
};
